export const BASE_PATH = typeof window === "undefined"
    ? process.env.NEXT_PUBLIC_BACKEND_URL
    : process.env.NEXT_PUBLIC_BACKEND_URL;

export type {} from "./generated-api";
